module.exports = __webpack_public_path__ + "static/media/homeSection1pic.4d7eef19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/homeSection1pic.jpg
// module id = 32
// module chunks = 0